import styled from 'styled-components';

export const CardNumber = styled.span`
    color: #1a1f36;
    font-weight: 500;
}
`;

export const ExpirationDate = styled.span`
    color: #767777;
    font-weight: 350;
}
`;
